var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27086 20.6546C10.5491 22.198 20.9339 21.2773 20.9339 15.8608V4.13375C20.9339 3.43962 20.8581 2.80535 20.6917 2.26787M3.27086 20.6546C1.4934 20.2777 0.473585 18.2264 0.587487 16.188C0.766803 12.979 0.657206 8.93135 0.505134 5.71507C0.37809 3.02811 2.62891 0.663164 5.01029 0.750085C9.26594 0.905417 14.877 0.702292 18.2912 0.505417C19.5864 0.430734 20.3406 1.13385 20.6917 2.26787M3.27086 20.6546C4.06586 20.9723 4.99168 21.2879 6 21.5658M20.6917 2.26787C22.6097 3.68217 22.63 11.9191 22.4004 15.8608C20.3478 23.5194 11.8061 23.1662 6 21.5658M20.6917 2.26787C21.2612 4.01192 22.2203 9.17216 21.5 15.8608C20.7797 22.5494 10.8665 22.4511 6 21.5658M9.44496 8.5C8.78897 9.11644 7.13215 10.497 5.54814 11.2966C5.48257 11.3297 5.48456 11.4753 5.55061 11.5063C6.55496 11.9779 8.42941 13.4264 9.44496 14.5M5.94444 11.4667C8.36549 11.5608 13.5 11.5 15.5 10.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4758975e5fe271ac436895d785cbf976.svg";
export { ForwardRef as ReactComponent };